module.exports = __webpack_public_path__ + "assets/img/portfolio-pirmas.1a58baf7.jpg";